import { render, staticRenderFns } from "./vipType-drawer.vue?vue&type=template&id=39d3e937&"
import script from "./vipType-drawer.vue?vue&type=script&lang=js&"
export * from "./vipType-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports